import { ITableRow } from '../../../services/dashboard';

interface IFilterOptions {
  isEffect?: boolean;
  reportLabels: { yes: string; no: string };
}

const getRowSearchText = (row: ITableRow, { isEffect, reportLabels }: IFilterOptions) => {
  const cells = [
    row.name,
    row.report_exist ? reportLabels.yes : reportLabels.no,
    row.invited,
    `${row.completed} (${row.completed_ratio}%)`,
    `${row.not_completed} (${row.not_completed_ratio}%)`,
  ];

  if (isEffect) {
    cells.push(row.internal_completed_ratio ?? '-', row.external_completed_ratio ?? '-');
  }

  return cells.join(' ').toLowerCase();
};

const filterDepartmentRows = (
  rows: ITableRow[],
  phrase: string,
  options: IFilterOptions
): ITableRow[] => {
  const terms = phrase.trim().toLowerCase().split(/\s+/).filter(Boolean);

  if (!terms.length) {
    return rows;
  }

  return rows.filter(row => {
    const text = getRowSearchText(row, options);
    return terms.every(term => text.includes(term));
  });
};

export default filterDepartmentRows;
